import React, { Component } from 'react';
import i18n from 'ar-i18n';


// Component for Announcement
class Announcement extends Component {
    render() {
        // Stop showing the maintenance notice since YYYY-MM-DD JST.
        const endOfMaintenance = i18n.moment.utc('2019-10-01T18');
        let showMaintenanceNotice = false;
        if (i18n.moment.utc().isBefore(endOfMaintenance)) {
            showMaintenanceNotice = true;
        }
        return (
            <div>
                <div className='section-header'>
                    { i18n.gettext('Notice') }
                </div>
                { showMaintenanceNotice ?
                    <div className='section-left-margin maintenance'>
                        <div className='highlighted-content'>
                            { i18n.gettext('Notice of scheduled maintenance') }
                        </div>

                        <div>
                            { i18n.gettext('Thank you for using RDTA') }
                            <br />
                            { i18n.gettext('Maintenance details1') }
                            <br />
                            { i18n.gettext('Maintenance details2') }
                            <br />
                        </div>
                        { this.renderMaintenanceSchedule() }
                        <div>
                            { i18n.gettext('Maintenance acknowledgement') }
                        </div>
                    </div> : null
                }
                <div className='section-left-margin'>
                    <div className='highlighted-content'>
                        { i18n.gettext('How to check the performance report') }
                    </div>
                    <div>
                        { i18n.gettext('Data reflection period differs between Performance and Daily Performance.') }
                        <a href='https://www.rakuten.co.jp/shops/manual/navi/promotion/07_r004.html#link-03' target='_blank' className='red-link'>{ i18n.gettext('Manual') }</a>
                        { i18n.gettext('Please check the details.') }
                    </div>

                    <br />

                    <div className='highlighted-content'>
                        { i18n.gettext('Please also use RUx')}
                    </div>
                    <div>
                        <a href='https://daigaku.rms.rakuten.co.jp/rmsapp/watch/50162' target='_blank' className='red-link'>{ i18n.gettext('Operation Manual Video') }</a>
                        { i18n.gettext('and') }
                        <a href='https://daigaku.rms.rakuten.co.jp/rmsapp/watch/50161' target='_blank' className='red-link'>{ i18n.gettext('The mechanism and merit of this advertisement') }</a>
                        { i18n.gettext('I am telling you. Please listen.') }
                    </div>

                    <br />

                    <div className='highlighted-content'>
                        { i18n.gettext('Guide concerning change of billing month') }
                    </div>
                    <div>
                        { i18n.gettext('The billing month of this ad is different from other advertisements.') }
                        <br />
                        { i18n.gettext('We will charge you two months after the advertisement posting month, and then it will be payment by the end of the next month.') }
                        <br />
                        { i18n.gettext('Detail is') }
                        <a href='http://rd.rakuten.co.jp/rn/support_n/1702/09/32246775/?shops-2' target='_blank' className='red-link'>{ i18n.gettext('Click here') }</a>
                        { i18n.gettext('Please confirm.') }
                    </div>
                </div>
            </div>);
    }

    renderMaintenanceSchedule() {
        const maintenanceRanges = [
            {
                start: {year: '2019', month: '6', day: '30', hour: '18', minute: '59'},
                end: {year: '2019', month: '3', day: '28', hour: '09', minute: '00'}
            }
        ];

        const maintenanceMessages = maintenanceRanges.map(maintenance => {
            return i18n.gettext(
                'Service end date: {{y1}}-{{m1}}-{{d1}} {{H1}}:{{M1}}',
                {
                    y1: maintenance.start.year,
                    m1: maintenance.start.month,
                    d1: maintenance.start.day,
                    H1: maintenance.start.hour,
                    M1: maintenance.start.minute
                }
            );
        });

        return (
            <div className='maintenance-date'>
                <div className='inline-div maintenance-date__title'>【日時】</div>
                <div className='inline-div'>
                    { maintenanceMessages.map((message, index) => <div key={ index }>{message}</div>) }
                </div>
            </div>
        );
    }
}

export default Announcement;
